import { Box, CircularProgress } from "@mui/material";

export const ProjectLoader = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        margin: "auto",
        marginTop: "20%",
      }}
      width="100%"
      height="100%"
    >
      <CircularProgress />
    </Box>
  );
};
